import React from 'react'
import { APPOINTMENT_STATES } from '../../helpers/constants'
import { OrderAppointmentState } from '../../model'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface AppointmentStateLabelProps {
    state: OrderAppointmentState | undefined
}

const AppointmentStateLabel: React.FunctionComponent<AppointmentStateLabelProps> = ({
    state
}: AppointmentStateLabelProps) => {
    const labelConfig = APPOINTMENT_STATES.find((app) => app.value === state)
    return (
        <div className='space-x-2 flex items-center'>
            {/* STATUS */}
            <DynamicFaIcon
                className='text-xs rounded-full'
                style={{ color: labelConfig?.hexColor, backgroundColor: labelConfig?.hexColor }}
                iconName='circle'
            />
            <span className='font-medium text-xs'>{labelConfig?.label}</span>
        </div>
    )
}

export default AppointmentStateLabel
